import React, { Component } from 'react';
import ChartHolder from './chartHolder/chartHolder';
import './charts.css'
import $ from 'jquery';

class Charts extends Component {
    componentDidMount(){
        this.props.openInstuctions(true);
    }
    returnChartValues = (resultsForChart, name, id) =>{
        let chartValues = [];
        let token = localStorage.getItem('token');
        let arraysForBack = [];
        let linkName = "";
        console.log(resultsForChart);
        switch(name){
            case 'Test1': {

            }; break;
            case 'Test2': {
                let firstChart = {};
                let secondChart = {};
                let chartData1 = {
                    answerByType : 0,
                    correctByType : 0,
                    answerTimeByType : 0,
                }
                let chartData2 = {
                    answerByType : 0,
                    correctByType : 0,
                    answerTimeByType : 0,
                }
                let chartData3 = {
                    answerByType : 0,
                    correctByType : 0,
                    answerTimeByType : 0,
                }

                for(let i=0; i<resultsForChart.length; i++){
                    if(resultsForChart[i].answered){
                        if(resultsForChart[i].similarityType == "ფიზიკური მსგავსება"){
                            chartData1.answerByType ++;
                            chartData1.answerTimeByType += resultsForChart[i].answerTime;
                            if(resultsForChart[i].isUserAnswerCorrect){
                                chartData1.correctByType ++;
                            }
                        }
                        if(resultsForChart[i].similarityType == "სახელწოდებით მსგავსება"){
                            chartData2.answerByType ++;
                            chartData2.answerTimeByType += resultsForChart[i].answerTime;
                            if(resultsForChart[i].isUserAnswerCorrect){
                                chartData2.correctByType ++;
                            }
                        }
                        if(resultsForChart[i].similarityType == "განსხვავებული"){
                            chartData3.answerByType ++;
                            chartData3.answerTimeByType += resultsForChart[i].answerTime;
                            if(resultsForChart[i].isUserAnswerCorrect){
                                chartData3.correctByType ++;
                            }
                        }
                    }
                }
                let firstChartoptions = {
                    chart :{
                        id: "basic-bar"
                    },
                    xaxis: {
                        categories : ['ფიზიკური მსგავსება', 'სახელწოდებით მსგავსება', 'განსხვავებული'],
                        title:{
                            text:"მსგავსების ტიპი"
                        }
                    },
                    yAxis : {
                        categories : [
                            parseInt(Math.round(chartData1.answerTimeByType / chartData1.answerByType)),
                            parseInt(Math.round(chartData2.answerTimeByType / chartData2.answerByType)),
                            parseInt(Math.round(chartData3.answerTimeByType / chartData3.answerByType))
                        ],
                        min: 0,
                        title:{
                            text:"რეაქციის დრო(მილიწამი)"
                        }
                    },
                    title: {
                        text: 'რეაქციის დრო როგორც მსგავსების ტიპის ფუნქცია',
                        align: 'center'
                    }                    
                };
                let firstChartseries= [
                    {
                        data : [
                            parseInt(Math.round(chartData1.answerTimeByType / chartData1.answerByType)),
                            parseInt(Math.round(chartData2.answerTimeByType / chartData2.answerByType)),
                            parseInt(Math.round(chartData3.answerTimeByType / chartData3.answerByType))
                        ],
                    }
                ];
                let secondChartoptions = {
                    chart :{
                        id: "basic-bar"
                    },
                    xaxis: {
                        categories : ['ფიზიკური მსგავსება', 'სახელწოდებით მსგავსება', 'განსხვავებული'],
                        title:{
                            text:"მსგავსების ტიპი"
                        }
                    },
                    yAxis : {
                        categories : [
                            parseInt(Math.round((chartData1.correctByType / chartData1.answerByType) * 100)),
                            parseInt(Math.round((chartData2.correctByType / chartData2.answerByType) * 100)),
                            parseInt(Math.round((chartData3.correctByType / chartData3.answerByType) * 100))
                        ],
                        min: 0,
                        max : 100,
                        title:{
                            text:"სისწორე"
                        }
                    },
                    title: {
                        text: 'სისწორე როგორც მსგავსების ტიპის ფუნქცია',
                        align: 'center'
                    }                    
                };
                let secondChartseries= [
                    {
                        data : [
                            parseInt(Math.round((chartData1.correctByType / chartData1.answerByType) * 100)),
                            parseInt(Math.round((chartData2.correctByType / chartData2.answerByType) * 100)),
                            parseInt(Math.round((chartData3.correctByType / chartData3.answerByType) * 100))
                        ],
                    }
                ];
                firstChart.options = firstChartoptions;
                firstChart.series = firstChartseries;
                secondChart.options = secondChartoptions;
                secondChart.series = secondChartseries;
                arraysForBack=[
                    {
                        chartArray: {
                            x :['ფიზიკური მსგავსება', 'სახელწოდებით მსგავსება', 'განსხვავებული'],
                            y :[
                                parseInt(Math.round(chartData1.answerTimeByType / chartData1.answerByType)),
                                parseInt(Math.round(chartData2.answerTimeByType / chartData2.answerByType)),
                                parseInt(Math.round(chartData3.answerTimeByType / chartData3.answerByType))
                            ]
                        }
                    },
                    {
                        chartArray : {
                           x : ['ფიზიკური მსგავსება', 'სახელწოდებით მსგავსება', 'განსხვავებული'],
                           y : [
                                parseInt(Math.round((chartData1.correctByType / chartData1.answerByType) * 100)),
                                parseInt(Math.round((chartData2.correctByType / chartData2.answerByType) * 100)),
                                parseInt(Math.round((chartData3.correctByType / chartData3.answerByType) * 100))
                            ]
                        }
                    },
                ]
                chartValues.push(secondChart, firstChart);
                linkName = "percdiagram";

            }; break;
            case 'Test3': {

                linkName = "strupdiagram";
            }; break;
            case 'Test4': {
                let firstChart = {};
                let secondChart = {};
                let thirdCHart = {}
                let fourthChart = {};

                let chartdata1 = {
                    answerByType : 0,
                    answerTimeByType : 0,
                    correctByType : 0,
                    correctByMargin : 0,
                    answerByMargin : 0,
                    answerTimeByMargin : 0
                }
                let chartdata2 = {
                    answerByType : 0,
                    answerTimeByType : 0,
                    correctByType : 0,
                    correctByMargin : 0,
                    answerByMargin : 0,
                    answerTimeByMargin : 0

                }
                let chartdata3 = {
                    answerByType : 0,
                    answerTimeByType : 0,
                    correctByType : 0,
                    correctByMargin : 0,
                    answerByMargin : 0,
                    answerTimeByMargin : 0

                }
                // debugger;
                for(let i = 0; i<resultsForChart.length; i++){
                    if(resultsForChart[i].answered){
                        if(resultsForChart[i].distractorType === "თავსებადი"){
                            chartdata1.answerByType = chartdata1.answerByType + 1;
                            chartdata1.answerTimeByType = chartdata1.answerTimeByType + resultsForChart[i].answerTime;
                            if(resultsForChart[i].isUserAnswerCorrect){
                                chartdata1.correctByType = chartdata1.correctByType +1;
                            }
                        }
                        if(resultsForChart[i].margin === "1"){
                            chartdata1.answerByMargin = chartdata1.answerByMargin + 1;
                            chartdata1.answerTimeByMargin = chartdata1.answerByMargin + resultsForChart[i].answerTime;
                            if(resultsForChart[i].isUserAnswerCorrect){
                                chartdata1.correctByMargin = chartdata1.correctByMargin + 1;
                            }
                        }
                        if(resultsForChart[i].distractorType === "ნეიტრალური"){
                            chartdata2.answerByType = chartdata2.answerByType + 1;
                            chartdata2.answerTimeByType = chartdata2.answerTimeByType + resultsForChart[i].answerTime;
                            if(resultsForChart[i].isUserAnswerCorrect){
                                chartdata2.correctByType = chartdata2.correctByType +1;
                            }
                        }
                        if(resultsForChart[i].margin === "2"){
                            chartdata2.answerByMargin = chartdata2.answerByMargin + 1;
                            chartdata2.answerTimeByMargin = chartdata2.answerByMargin + resultsForChart[i].answerTime;
                            if(resultsForChart[i].isUserAnswerCorrect){
                                chartdata2.correctByMargin = chartdata2.correctByMargin + 1
                            }
                        }

                        if(resultsForChart[i].distractorType === "არათავსებადი"){
                            chartdata3.answerByType = chartdata3.answerByType + 1;
                            chartdata3.answerTimeByType = chartdata3.answerTimeByType + resultsForChart[i].answerTime;
                            if(resultsForChart[i].isUserAnswerCorrect){
                                chartdata3.correctByType = chartdata3.correctByType +1;
                            }
                        }
                        if(resultsForChart[i].margin === "3"){
                            chartdata3.answerByMargin = chartdata3.answerByMargin + 1;
                            chartdata3.answerTimeByMargin = chartdata3.answerByMargin + resultsForChart[i].answerTime;
                            if(resultsForChart[i].isUserAnswerCorrect){
                                chartdata3.correctByMargin = chartdata3.correctByMargin + 1
                            }
                        }
                    }
                }
                
                let firstChartFirstElement = isNaN(parseInt(Math.round(chartdata1.correctByType / chartdata1.answerByType * 100))) ? 0 : parseInt(Math.round(chartdata1.correctByType / chartdata1.answerByType * 100));
                let firstCHartSecondElement = isNaN(parseInt(Math.round(chartdata2.correctByType / chartdata2.answerByType * 100))) ? 0 : parseInt(Math.round(chartdata2.correctByType / chartdata2.answerByType * 100));
                let firstChartThirdElement = isNaN(parseInt(Math.round(chartdata3.correctByType / chartdata3.answerByType * 100))) ? 0 : parseInt(Math.round(chartdata3.correctByType / chartdata3.answerByType * 100));
                let firstChartoptions = {
                    chart :{
                        id: "basic-bar"
                    },
                    xaxis: {
                        categories : ['თავსებადი', 'არათავსებადი', 'ნეიტრალური'],
                        title:{
                            text:"დისტრაქტორი სტიმულის ტიპი"
                        }
                    },
                    yAxis : {
                        categories : [
                            firstChartFirstElement,
                            firstCHartSecondElement,
                            firstChartThirdElement
                        ],
                        min: 0,
                        max : 100,
                        title:{
                            text:"სისწორე"
                        }
                    },
                    title: {
                        text: 'პასუხების სისწორე როგორც დისტრაქტორი სტიმულის ტიპის ფუნქცია',
                        align: 'center'
                    }                    
                };
                let firstChartseries= [
                    {
                        name: 'series-1',
                        data: [
                            firstChartFirstElement,
                            firstCHartSecondElement,
                            firstChartThirdElement
                        ]
                    }
                ];

                let secondChartFirstElement = isNaN(parseInt(Math.round(chartdata1.correctByMargin / chartdata1.answerByMargin * 100))) ? 0 : parseInt(Math.round(chartdata1.correctByMargin / chartdata1.answerByMargin * 100))
                let secondChartSecondElement = isNaN(parseInt(Math.round(chartdata2.correctByMargin / chartdata2.answerByMargin * 100))) ? 0 : parseInt(Math.round(chartdata2.correctByMargin / chartdata2.answerByMargin * 100));
                let secondChartThirdElement = isNaN(parseInt(Math.round(chartdata3.correctByMargin / chartdata3.answerByMargin * 100))) ? 0 : parseInt(Math.round(chartdata3.correctByMargin / chartdata3.answerByMargin * 100));
                
                let secondChartoptions = {
                    chart :{
                        id: "basic-bar"
                    },
                    xaxis: {
                        categories : ['1', '2', '3'],
                        title: {
                            text : "დაშორება"
                        }
                    },
                    yaxis : {
                        categories : [ 
                            secondChartFirstElement,
                            secondChartSecondElement,
                            secondChartThirdElement
                        ],
                        min: 0,
                        max : 100,
                        title: {
                            text : "სისწორე(პროცენტი %)"
                        }

                    },
                    title: {
                        text: 'პასუხების სისწორე როგორც სტიმულთა შორის დაშორების ფუნქცია',
                        align: 'center'
                    }
                };
                let secondChartseries= [
                    {
                        name: 'series-1',
                        data: [
                            secondChartFirstElement,
                            secondChartSecondElement,
                            secondChartThirdElement
                        ]
                    }
                ];

                let thirdChartFirstElement = isNaN(parseInt(Math.round(chartdata1.answerTimeByType / chartdata1.answerByType))) ? 0 : parseInt(Math.round(chartdata1.answerTimeByType / chartdata1.answerByType));
                let thirdChartSecondElement = isNaN(parseInt(Math.round(chartdata2.answerTimeByType / chartdata2.answerByType))) ? 0 : parseInt(Math.round(chartdata2.answerTimeByType / chartdata2.answerByType));
                let thirdChartThridElement = isNaN(parseInt(Math.round(chartdata3.answerTimeByType / chartdata3.answerByType))) ? 0 : parseInt(Math.round(chartdata3.answerTimeByType / chartdata3.answerByType));
                let thirdChartoptions = {
                    chart :{
                        id: "basic-bar"
                    },
                    xaxis: {
                        categories : ['თავსებადი', 'არათავსებადი', 'ნეიტრალური'],
                        title:{
                            text:"დისტრაქტორი სტიმულის ტიპი"
                        }
                    },
                    yaxis:{
                        categories : [
                            thirdChartFirstElement,
                            thirdChartSecondElement,
                            thirdChartThridElement
                        ],
                        min: 0,
                        title:{
                            text: "რეაქციის დრო(მილიწამი)"
                        }
                    },
                    title: {
                        text: 'რეაქციის დროის საშუალო როგორც დისტრაქტორი სტიმულების ტიპის ფუნქცია',
                        align: 'center'
                    }
                };
                let thirdChartseries= [
                    {
                        name: 'series-1',
                        data: [
                            thirdChartFirstElement,
                            thirdChartSecondElement,
                            thirdChartThridElement
                        ]
                    }
                ];

                let fourthChartFirstElement = isNaN(parseInt(Math.round(chartdata1.answerTimeByMargin / chartdata1.answerByMargin))) ? 0 : parseInt(Math.round(chartdata1.answerTimeByMargin / chartdata1.answerByMargin));
                let fourthCHartSecondElement = isNaN(parseInt(Math.round(chartdata2.answerTimeByMargin / chartdata2.answerByMargin))) ? 0 : parseInt(Math.round(chartdata2.answerTimeByMargin / chartdata2.answerByMargin));
                let fourthCHartThirdElement = isNaN(parseInt(Math.round(chartdata3.answerTimeByMargin / chartdata3.answerByMargin))) ? 0 : parseInt(Math.round(chartdata3.answerTimeByMargin / chartdata3.answerByMargin));
                let fourthChartoptions = {
                    chart :{
                        id: "basic-bar"
                    },
                    xaxis: {
                        categories : ['1', '2', '3'],
                        title: {
                            text : "დაშორება"
                        }
                    },
                    yaxis : {
                        categories : [
                            fourthChartFirstElement,
                            fourthCHartSecondElement,
                            fourthCHartThirdElement
                        ],
                        min : 0,
                        title: {
                            text: "რეაქციის დრო"
                        }
                    },
                    title: {
                        text: 'რეაქციის დროის საშუალო როგორც სტიმულთა შორის დაშორების ფუნქციაა',
                        align: 'center'
                    }
                }
                let fourthChartseries = [
                    {
                        name: 'series-1',
                        data: [
                            fourthChartFirstElement,
                            fourthCHartSecondElement,
                            fourthCHartThirdElement
                        ]
                    }
                ]
                firstChart.options = firstChartoptions;
                firstChart.series = firstChartseries;
                secondChart.options = secondChartoptions;
                secondChart.series = secondChartseries;
                thirdCHart.options = thirdChartoptions;
                thirdCHart.series = thirdChartseries;
                fourthChart.options = fourthChartoptions;
                fourthChart.series = fourthChartseries;
                arraysForBack=[
                    {
                        chartArray: {
                            x :['თავსებადი', 'არათავსებადი', 'ნეიტრალური'],
                            y :[
                                parseInt(Math.round(chartdata1.correctByType / chartdata1.answerByType * 100)),
                                parseInt(Math.round(chartdata2.correctByType / chartdata2.answerByType * 100)),
                                parseInt(Math.round(chartdata3.correctByType / chartdata3.answerByType * 100))
                            ]
                        }
                    },
                    {
                        chartArray : {
                           x : ['1', '2', '3'],
                           y : [
                                parseInt(Math.round(chartdata1.correctByMargin / chartdata1.answerByMargin * 100)),
                                parseInt(Math.round(chartdata2.correctByMargin / chartdata2.answerByMargin * 100)),
                                parseInt(Math.round(chartdata3.correctByMargin / chartdata3.answerByMargin * 100))
                            ]
                        }
                    },
                    {
                        chartArray : {
                           x : ['თავსებადი', 'არათავსებადი', 'ნეიტრალური'],
                           y : [
                                parseInt(Math.round(chartdata1.answerTimeByType / chartdata1.answerByType)),
                                parseInt(Math.round(chartdata2.answerTimeByType / chartdata2.answerByType)),
                                parseInt(Math.round(chartdata3.answerTimeByType / chartdata3.answerByType))
                            ]
                        }
                    },
                    {
                        chartArray : {
                           x : ['1', '2', '3'],
                           y : [
                                parseInt(Math.round(chartdata1.answerTimeByMargin / chartdata1.answerByMargin)),
                                parseInt(Math.round(chartdata2.answerTimeByMargin / chartdata2.answerByMargin)),
                                parseInt(Math.round(chartdata3.answerTimeByMargin / chartdata3.answerByMargin))
                            ]
                        }
                    }
                ]
                linkName = "selectdiagram";
                chartValues.push(firstChart,secondChart,thirdCHart,fourthChart);

                arraysForBack=[
                    {
                        chartArray: {
                            x :['თავსებადი', 'არათავსებადი', 'ნეიტრალური'],
                            y :[                           
                                firstChartFirstElement,
                                firstCHartSecondElement,
                                firstChartThirdElement
                            ]
                        }
                    },
                    {
                        chartArray : {
                           x : ['1', '2', '3'],
                           y : [ 
                            secondChartFirstElement,
                            secondChartSecondElement,
                            secondChartThirdElement
                           ]
                        }
                    },
                    {
                        chartArray : {
                           x : ['თავსებადი', 'არათავსებადი', 'ნეიტრალური'],
                           y : [ 
                            thirdChartFirstElement,
                            thirdChartSecondElement,
                            thirdChartThridElement
                           ]
                        }
                    },
                    {
                        chartArray : {
                           x : ['1', '2', '3'],
                           y : [ 
                            fourthChartFirstElement,
                            fourthCHartSecondElement,
                            fourthCHartThirdElement
                           ]
                        }
                    }
                ];
            }; break;
            case 'Test5': {

            }; break;
            case 'Test6': {
                // debugger;
                let firstChart = {};
                let secondChart = {};
                let chart1data1 = {
                    typeCounter : 0,
                    time : 0,
                    correct : 0
                }
                let chart2data2 = {
                    typeCounter : 0,
                    time : 0,
                    correct : 0
                }
                for(let i =0; i<resultsForChart.length; i++){
                    if(resultsForChart[i].answered){
                        if(resultsForChart[i].type === "type1" || resultsForChart[i].type === "type2"){
                            chart1data1.typeCounter = chart1data1.typeCounter += 1;
                            chart1data1.time =  chart1data1.time += resultsForChart[i].answerTime;
                            if(resultsForChart[i].isUserAnswerCorrect){
                                chart1data1.correct = chart1data1.correct += 1;
                            }
                        }
                        if(resultsForChart[i].type === "type3"){
                            chart2data2.typeCounter = chart2data2.typeCounter += 1;
                            chart2data2.time = chart2data2.time += resultsForChart[i].answerTime;
                            if(resultsForChart[i].isUserAnswerCorrect){
                                chart2data2.correct = chart2data2.correct += 1;
                            }
                        }
                    }
                }
                let firstChartoptions = {
                    chart :{
                        id: "basic-bar"
                    },
                    xaxis: {
                        categories : ['ორი ასო', 'ოთხი ასო'],
                        title:{
                            text:"ალტერნატივათა რაოდენობა"
                        }
                    },
                    yaxis : {
                        categories : [parseInt(Math.round(chart1data1.time / chart1data1.typeCounter)),parseInt(Math.round(chart2data2.time/chart2data2.typeCounter))],
                        title:{
                            text:"რეაქციის დრო(მილიწამი)"
                        }
                    },
                    title: {
                        text: 'რეაქციის დრო როგორც სტიმულების რაოდენობის ფუნქცია',
                        align: 'center'
                    }                    
                };
                let firstChartseries= [
                    {
                        data : [parseInt(Math.round(chart1data1.time / chart1data1.typeCounter)),parseInt(Math.round(chart2data2.time/chart2data2.typeCounter))],
                    }
                ];
                let secondChartoptions = {
                    chart :{
                        id: "basic-bar"
                    },
                    xaxis: {
                        categories : ['ორი ასო', 'ოთხი ასო'],
                        title:{
                            text:"ალტერნატივათა რაოდენობა"
                        }
                    },
                    yaxis : {
                        categories : [ Math.round(chart1data1.correct / chart1data1.typeCounter*100),Math.round(chart2data2.correct / chart1data1.typeCounter*100)],
                        min: 0,
                        max: 100,
                        title: {
                            text : "სისწორე(პროცენტი %)"
                        }

                    },
                    title: {
                        text: 'სისწორე როგორც სტიმულის სახის ფუნქცია',
                        align: 'center'
                    }
                };
                let secondChartseries= [
                    {
                        name: 'series-1',
                        data: [ Math.round(chart1data1.correct / chart1data1.typeCounter*100),Math.round(chart2data2.correct / chart2data2.typeCounter*100)]
                    }
                ];
                firstChart.options = firstChartoptions;
                firstChart.series = firstChartseries;
                secondChart.options = secondChartoptions;
                secondChart.series = secondChartseries;
                chartValues.push(secondChart, firstChart);

                arraysForBack=[
                    {
                        chartArray: {
                            x :['ორი ასო', 'ოთხი ასო'],
                            y :[parseInt(Math.round(chart1data1.time / chart1data1.typeCounter)),parseInt(Math.round(chart2data2.time/chart2data2.typeCounter))]
                        }
                    },
                    {
                        chartArray : {
                           x : ['ორი ასო', 'ოთხი ასო'],
                           y : [ Math.round(chart1data1.correct / chart1data1.typeCounter*100),Math.round(chart2data2.correct / chart2data2.typeCounter*100)]
                        }
                    }
                ];

                linkName="reaqdiagram";
            }; break;
            case 'Test7': {
                // debugger;
                let firstChart = {};
                let secondChart = {};
                let thirdCHart = {}
                let fourthChart = {};
                let chart1data1={
                    timeCouner:0,
                    time:0,
                    correct: 0,
                    answerCounter :0,
                };

                let chart2data2={
                    timeCouner:0, 
                    time:0,
                    correct: 0,
                    answerCounter : 0         
                };
                let degrees = [];
                for(let i =0 ;i<resultsForChart.length; i++){
                    degrees.push(resultsForChart[i].degree);
                    if(resultsForChart[i].answered){
                        if(resultsForChart[i].reverse === "სარკული"){
                            chart2data2.timeCouner = chart2data2.timeCouner+=1;
                            chart2data2.time = chart2data2.time += resultsForChart[i].answerTime;
                            chart2data2.answerCounter += 1;
                            if(resultsForChart[i].isUserAnswerCorrect){
                                chart2data2.correct = chart2data2.correct +=1;
                            }
                        }
                        if(resultsForChart[i].reverse === "არასარკული"){
                            chart1data1.timeCouner = chart1data1.timeCouner+=1;
                            chart1data1.time = chart1data1.time += resultsForChart[i].answerTime;
                            chart1data1.answerCounter += 1;

                            if(resultsForChart[i].isUserAnswerCorrect){
                                chart1data1.correct = chart1data1.correct +=1;
                            }
                        }
                    }
                }
                degrees = [...new Set(degrees)];
                degrees.sort(function(a,b){return a-b});
                console.log(degrees);
                // degrees = degrees.sort();
                let degreesAnswer = {};
                let degTimeCount = {};
                let degCorrect = {};
                let degAnswered = {};
                degrees.map(degree=>{
                    degreesAnswer[degree] = 0;
                });
                degrees.map(degree=>{
                    degTimeCount[degree] = 0;
                });
                degrees.map(degree=>{
                    degCorrect[degree] = 0;
                });
                degrees.map(degree=>{
                    degAnswered[degree] = 0;
                })
                for(let i=0; i<resultsForChart.length; i++){
                    let degree = resultsForChart[i].degree;
                    if(resultsForChart[i].answered){
                        degreesAnswer[degree] = degreesAnswer[degree] + resultsForChart[i].answerTime;
                        degTimeCount[degree] = degTimeCount[degree] += 1;
                        degAnswered[degree] = degAnswered[degree] += 1;
                        if(resultsForChart[i].isUserAnswerCorrect){
                            degCorrect[degree] = degCorrect[degree] += 1;
                        }
                    }
                }

                let thirdChartData = [];
                let fourthChartData = [];
                for(let key in degreesAnswer){
                    thirdChartData.push(isNaN(Math.round(degreesAnswer[key]/degTimeCount[key])) ? 0 : Math.round(degreesAnswer[key]/degTimeCount[key]));
                }
                for(let key in degCorrect){
                    fourthChartData.push(isNaN(Math.round(degCorrect[key]/degAnswered[key]*100)) ? 0 : Math.round(degCorrect[key]/degAnswered[key]*100));
                }
                let firstChartoptions = {
                    chart :{
                        id: "basic-bar"
                    },
                    xaxis: {
                        categories : ['არასარკული', 'სარკული'],
                        title:{
                            text:"სტიმულის სახე"
                        }
                    },
                    yaxis : {
                        categories : [parseInt(Math.round(chart1data1.time / chart1data1.timeCouner)),parseInt(Math.round(chart2data2.time/chart2data2.timeCouner))],
                        title: {
                            text : "რეაქციის დრო (მილიწამი)"
                        }
                    },
                    title: {
                        text: 'რეაქციის დრო როგორც სტიმულის სახის ფუნქცია',
                        align: 'center'
                    }                    
                };
                let firstChartseries= [
                    {
                        name: 'series-1',
                        data: [parseInt(Math.round(chart1data1.time / chart1data1.timeCouner)),parseInt(Math.round(chart2data2.time/chart2data2.timeCouner))]
                    }
                ];
                let secondChartoptions = {
                    chart :{
                        id: "basic-bar"
                    },
                    xaxis: {
                        categories : ['არასარკული', 'სარკული'],
                        title: {
                            text : "სტიმულის სახე"
                        }
                    },
                    yaxis : {
                        categories : [ Math.round(chart1data1.correct / chart1data1.answerCounter*100),Math.round(chart2data2.correct / chart1data1.answerCounter*100)],
                        min: 0,
                        max: 100,
                        title: {
                            text : "სისწორე(პროცენტი %)"
                        }
                    },
                    title: {
                        text: 'სისწორე როგორც სტიმულის სახის ფუნქცია',
                        align: 'center'
                    }
                };
                let secondChartseries= [
                    {
                        name: 'series-1',
                        data: [ Math.round(chart1data1.correct / chart1data1.answerCounter*100),Math.round(chart2data2.correct / chart2data2.answerCounter*100)]
                    }
                ];
                let thirdChartoptions = {
                    chart :{
                        id: "basic-bar"
                    },
                    xaxis: {
                        categories : degrees,
                        title : {
                            text:"ბრუნვის კუთხე(გრადუსი)"
                        }
                    },
                    yaxis:{
                        categories : thirdChartData,
                        title:{
                            text: "რეაქციის დრო(მილიწამი)"
                        }
                    },
                    title: {
                        text: 'რეაქციის დრო როგორც ბრუნვის კუთხის ფუნქცია',
                        align: 'center'
                    }
                };
                let thirdChartseries= [
                    {
                        name: 'series-1',
                        data: thirdChartData
                    }
                ];
                let fourthChartoptions = {
                    chart :{
                        id: "basic-bar"
                    },
                    xaxis: {
                        categories : degrees,
                        title: {
                            text : "ბრუნვის კუთხე(გრადუსი)"
                        }
                    },
                    yaxis : {
                        categories : fourthChartData,
                        min : 0,
                        max : 100,
                        title: {
                            text: "სისწორე(პროცენტი)"
                        }
                    },
                    title: {
                        text: 'სისწორე როგორც ბრუნვის კუთხის ფუნქცია',
                        align: 'center'
                    }
                }
                let fourthChartseries = [
                    {
                        name: 'series-1',
                        data: fourthChartData
                    }
                ]
                // console.log(degCorrect);

                firstChart.options = firstChartoptions;
                firstChart.series = firstChartseries;
                secondChart.options = secondChartoptions;
                secondChart.series = secondChartseries;
                thirdCHart.options = thirdChartoptions;
                thirdCHart.series = thirdChartseries;
                fourthChart.options = fourthChartoptions;
                fourthChart.series = fourthChartseries;
                chartValues.push(firstChart,secondChart,thirdCHart,fourthChart);
                arraysForBack=[
                    {
                        chartArray: {
                            x :['არასარკული', 'სარკული'],
                            y :[parseInt(Math.round(chart1data1.time / chart1data1.timeCouner)),parseInt(Math.round(chart2data2.time/chart2data2.timeCouner))]
                        }
                    },
                    {
                        chartArray : {
                           x : ['არასარკული', 'სარკული'],
                           y : [ Math.round(chart1data1.correct / chart1data1.answerCounter*100),Math.round(chart2data2.correct / chart2data2.answerCounter*100)]
                        }
                    },
                    {
                        chartArray: {
                            x : [...degrees],
                            y : [...thirdChartData]
                        }
                    },
                    {
                        chartArray : {
                           x : [...degrees],
                           y : [fourthChartData]
                        }
                    }
                ]

                linkName="mentaldiagram";
            }; break;
            case 'Test8' : {
                console.log()
            }
        }
        console.log(localStorage.getItem('new'));
        let isNew = localStorage.getItem('new');
        let date = localStorage.getItem('testDate');
        localStorage.setItem('new', false);
        if(isNew == "true"){
            for(let i=0; i<arraysForBack.length; i++){
                console.log(arraysForBack[i].chartArray);
                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN':  token
                    },
                    url : `http://psychologytest.tsu.ge/backend/diagram/${linkName}`,
                    dataType: 'json',
                    type: 'POST',
                    data : {
                        'id' : id,
                        'diagramx' : arraysForBack[i].chartArray.x.toString(),
                        'diagramy' : arraysForBack[i].chartArray.y.toString(),
                        'date' : date
                    },
                    success: (e)=>{
                        console.log(e);
                    },
                    error :(e)=>{
                        console.log(e)
                    }
        
               })
    
            }
            
        }
        return chartValues;
    }

    render() {
        let tableData =JSON.parse(localStorage.getItem('chartData'));
        const resultsForChart = tableData.results;
        let id = resultsForChart[0].id;
        let results = this.returnChartValues(resultsForChart, tableData.name, id);

        let element = null;
        if(tableData.name === "Test1"){
            element = <p className="chart-text">ამ ტიპის ტესტისთვის გრაფიკული გამოსახულებები ხელმისაწვდომი არ არის</p>
        }
        else{
            element = results.map((elem,i)=>{
                return  <ChartHolder key={i} options={elem.options} series={elem.series} type="line" width="800"/> 
            })
    
        }


        // if(options && series){
        //     console.log(options, series);
        //     element = <Chart options={options} series={series} type="line" width="800"/>
        // }
        return (
            <div className="charts-holder">
                {element}
            </div>
        );
    }
}

export default Charts; 

